var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "appwrapper",
      attrs: { "data-test-id": "onClick" },
      on: { click: _vm.onClick },
    },
    [
      _c(
        "v-app",
        { style: _vm.appFonts },
        [
          _vm.notification
            ? _c("Notification", { attrs: { message: _vm.notification } })
            : _vm._e(),
          _c("AdvWorker"),
          _vm.isGuarded ? _c("AdvHeader") : _vm._e(),
          _c("AdvView"),
          _vm.isGuarded || _vm.isRiaOnboarding ? _c("AdvFooter") : _vm._e(),
          _vm.isGuarded
            ? _c("AdvLogoutModal", { ref: "logoutModal" })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }